import * as React from "react"

export default function Quote({ width = 32, height = 32, fill = '#FFCB1F', ...props }) {
  return (
    <svg style={{ width: width, height: height }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM17.2246 24.4687L16.5371 21.3027C18.5515 20.8568 20.4039 20.2769 20.2539 18.0273H17.8867V9.60152H25.0176V17.4766C25.015 23.735 20.4202 24.2442 17.2246 24.4687ZM7.67187 24.4687L6.98243 21.3027C8.99685 20.8568 10.8492 20.2769 10.6992 18.0273H8.33203V9.60152H15.4629V17.4766C15.4604 23.735 10.8675 24.2442 7.67187 24.4687Z" fill="#B25E8B"/>
    </svg>
  )
}